import { useMemo } from 'react';
import { useExperimentContext } from '@americanexpress/one-experiments';
import { HOMEPAGE_REDESIGN_EXPERIMENT } from '../constants/experimentConstant';
import { useMosaicContext } from '../context/mosaicContext';

export const useIsHomePageVariantHook = () => {
  const isMosaicDesign = useMosaicContext();
  const { selectors: { getExperimentVariant } } = useExperimentContext();
  const experimentData = getExperimentVariant(HOMEPAGE_REDESIGN_EXPERIMENT);

  return useMemo(() => isMosaicDesign || (experimentData
    && experimentData.dimension === 'search_widget'
    && experimentData.variant !== 'control'), [isMosaicDesign, experimentData]);
};
